import { create } from "zustand";

export type ColorScheme = "light" | "dark";

/** `useRecentlyViewed.ts` bilan bir xil kalit naqshi (`skud.` prefiksi). */
export const COLOR_SCHEME_KEY = "skud-color-scheme";

/**
 * ⚠️ `localStorage` HAR DOIM `try/catch` ichida — brauzer sayt
 * ma'lumotlarini bloklaganda MUROJAAT QILISHNING O'ZI `SecurityError`
 * tashlaydi (`useRecentlyViewed.ts` bilan bir xil sabab).
 */
function readStoredScheme(): ColorScheme | null {
	try {
		const xom = window.localStorage.getItem(COLOR_SCHEME_KEY);

		return xom === "light" || xom === "dark" ? xom : null;
	} catch {
		return null;
	}
}

function writeStoredScheme(scheme: ColorScheme): void {
	try {
		window.localStorage.setItem(COLOR_SCHEME_KEY, scheme);
	} catch {
		// Saqlash imkoni yo'q — tanlov shu sessiyada amal qiladi.
	}
}

/**
 * OS'ning tungi rejim holati. `matchMedia` sekure context talab qilmaydi
 * (`secure-context.test.ts` TAQIQ ro'yxatida yo'q), lekin baribir
 * himoyalangan — eski brauzer yoki test muhitida mavjud bo'lmasligi mumkin.
 */
function prefersDarkOs(): boolean {
	try {
		return window.matchMedia("(prefers-color-scheme: dark)").matches;
	} catch {
		return false;
	}
}

/**
 * Boshlang'ich holat — spec §4: aniq saqlangan tanlov OS holatidan USTUN.
 * Eksport qilingan — testda modul yuklanishidan mustaqil to'g'ridan-to'g'ri
 * tekshirish uchun (`useRecentlyViewed.ts`ning `read()` naqshi).
 */
export function initialScheme(): ColorScheme {
	return readStoredScheme() ?? (prefersDarkOs() ? "dark" : "light");
}

/**
 * Tailwind `dark:` varianti (`index.css`, §5) va xarita CSS
 * o'zgaruvchilari (`map-theme.css`, §6) shu atributga tayanadi.
 */
function applyToDocument(scheme: ColorScheme): void {
	document.documentElement.dataset.theme = scheme;
}

interface ColorSchemeState {
	scheme: ColorScheme;
	setScheme: (scheme: ColorScheme) => void;
	toggle: () => void;
}

/**
 * ⚠️ Zustand do'koni, `useState` EMAS — `useRecentlyViewed.ts` bilan bir
 * xil sabab: `AntdProvider` (tema tanlash) va header'dagi `Switch`
 * (tanlovni o'zgartirish) ikkita ALOHIDA komponent, lekin bitta holatga
 * OBUNA bo'lishi shart. Mahalliy `useState` bo'lganda `Switch` bosilishi
 * `AntdProvider`ning mustaqil nusxasini ko'rmasdi.
 *
 * ⚠️ Boshlang'ich holat modul YUKLANGANDA (import paytida) bir marta
 * hisoblanadi va DARHOL `<html>`ga qo'llanadi — CSP `script-src 'self'`
 * bo'lgani uchun `index.html`dagi klassik inline-skript FOUC yechimi
 * ishlatilmaydi (CLAUDE.md, CSP bo'limi); bu yagona ruxsat etilgan o'rin.
 */
export const useColorSchemeStore = create<ColorSchemeState>((set, get) => ({
	scheme: initialScheme(),
	setScheme: (scheme) => {
		writeStoredScheme(scheme);
		applyToDocument(scheme);
		set({ scheme });
	},
	toggle: () => {
		get().setScheme(get().scheme === "dark" ? "light" : "dark");
	},
}));

applyToDocument(useColorSchemeStore.getState().scheme);

/** `AntdProvider` va header toggle shu hookdan foydalanadi. */
export function useColorScheme(): ColorSchemeState {
	return useColorSchemeStore();
}
